import React from "react";
import Switch from "react-switch";
import swal from "sweetalert";

import ImageDropZone from "../ImageDropZone";

import {
  EVENT_IMAGES,
  ASSETS_SERVER_PATH,
  VIEWER_ZONE_DOMAIN,
} from "../../config/defaults";
import sendToClipBoard from "../../services/sendToClipboard";

class CustomizePlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isUpdatingYoutube: false,
      hasYoutubeStreamTarget: true,
      useYoutube: props.event.live_stream.isByYoutube || false,
      playerAutoplay: props.event.player_autoplay === "true",
    };

    this.onCustomPlayer = this.onCustomPlayer.bind(this);
  }
  componentDidMount() {
    /*
		const self = this;
        this.props.firebase.db
			.collection('events')
			.doc(this.props.event.id)
			.collection('stream_targets')
			.get()
			.then((response) => {
				if (!response.empty) {
					let flag = false;
					response.forEach((streamTarget) => {
						if (streamTarget.data().type === 'youtube') {
							flag = true;
						}
					});
					if (flag) {
						self.setState({ hasYoutubeStreamTarget: true });
					}
				}
			});*/
  }
  onCustomPlayer(e) {
    e.preventDefault();
    const self = this,
      { player_title, player_destination, player_autoplay, youtube_url } =
        e.target.elements;

    this.setState({ isLoading: true }, () => {
      const data = {
        player_title: player_title.value,
        player_destination: player_destination.value,
        player_autoplay: player_autoplay.value,
      };

      if (youtube_url) {
        if (
          youtube_url.value.toLowerCase().startsWith("https://www.youtube.com/")
        ) {
          data["live_stream.youtube_url"] = youtube_url.value;
        } else {
          swal("Error", "Debes introducir una URL válida", "error");
          this.setState({ isLoading: false });
          return false;
        }
      }

      this.props
        .onCustomPlayer(data)
        .then(() => {
          self.setState({ isLoading: false }, () => {
            swal(
              "",
              "Los cambios han sido guardados, Recuerda que el código iframe cambia cada vez que realizas un cambio en esta interfaz y debes actualizarlo en tu sitio web",
              "success"
            );
          });
        })
        .catch((error) => {
          self.setState({ isLoading: false }, () => {
            console.error(error);
            swal("", "Hubo un error, por favor intentalo nuevamente", "error");
          });
        });
    });
  }
  render() {
    const { event = {} } = this.props,
      { isLoading, playerAutoplay, useYoutube, isUpdatingYoutube } = this.state,
      _playerTitle = event.player_title || event.name,
      _playerDestination = event.player_destination || "";

    let _defaultCode = `<style>.video-CeHis{position:relative;padding-bottom:56.25%;overflow:hidden}.video-CeHis iframe{position:absolute;display:block;top:0;left:0;width:100%;height:100%}</style><div class="video-CeHis" style="position:relative; padding-bottom:56.25%; overflow:hidden;"><iframe title="player" allowFullScreen="true" width="100%" scrolling="no" frameBorder="0" src="${VIEWER_ZONE_DOMAIN}/iframe/${event.url}"/></div>`,
      {
        IMAGE_PLAYER_BACKGROUND = EVENT_IMAGES.PLAYER_BACKGROUND,
        IMAGE_PLAYER_ICON = EVENT_IMAGES.PLAYER_ICON,
      } = event;

    if (IMAGE_PLAYER_BACKGROUND !== EVENT_IMAGES.PLAYER_BACKGROUND) {
      IMAGE_PLAYER_BACKGROUND =
        ASSETS_SERVER_PATH +
        "events/" +
        event.id +
        "/IMAGE/PLAYER_BACKGROUND" +
        IMAGE_PLAYER_BACKGROUND;
    }

    if (IMAGE_PLAYER_ICON !== EVENT_IMAGES.PLAYER_ICON) {
      IMAGE_PLAYER_ICON =
        ASSETS_SERVER_PATH +
        "events/" +
        event.id +
        "/IMAGE/PLAYER_ICON" +
        IMAGE_PLAYER_ICON;
    }

    return (
      <div className="row row-sm">
        <div className="col-md-8 row-eq-height">
          <form onSubmit={this.onCustomPlayer}>
            <div className="wizard clearfix">
              <div className="steps clearfix">
                <h5 id="wizard1-h-0" tabIndex="-1" className="title current">
                  Personalizar Reproductor
                </h5>
              </div>
              <div className="content clearfix pd-30 pd-sm-40">
                <div className="row row-xs align-items-center mg-b-20">
                  <div className="col-md-4">
                    <label className="form-label mg-b-0">Imagén de Fondo</label>
                  </div>
                  <div className="col-md-8 mg-t-5 mg-md-t-0">
                    <ImageDropZone
                      className="drop event_img_row col-md-12"
                      type="PLAYER_BACKGROUND"
                      eid={event.id}
                      onChangeImage={this.props.onChangeImage}
                      onDeleteImage={this.props.onDeleteImage}
                      onRequestLoading={this.props.onRequestLoading}
                      photoURL={`${IMAGE_PLAYER_BACKGROUND}?t=${this.props.timestamp}`}
                      onValidation={(file, _success) => {
                        const self = this;
                        var reader = new FileReader();

                        reader.onload = function (e) {
                          var img = new Image();
                          img.onload = function () {
                            if (
                              (this.width === 1280 && this.height === 720) ||
                              (this.width === 1920 && this.height === 1080)
                            ) {
                              _success();
                            } else {
                              swal(
                                "",
                                "La imagen debe tener una dimensión de 1280x720 o de 1920x1080",
                                "error"
                              );
                              self.props.onRequestLoading(false);
                            }
                          };
                          img.src = e.target.result;
                        };

                        reader.readAsDataURL(file);
                      }}
                    />
                  </div>
                </div>

                <div className="row row-xs align-items-center mg-b-20">
                  <div className="col-md-4">
                    <label className="form-label mg-b-0">
                      Ícono del reproductor
                    </label>
                  </div>
                  <div className="col-md-8 mg-t-5 mg-md-t-0">
                    <ImageDropZone
                      className="drop event_img_row event_img_row_512  col-md-12"
                      type="PLAYER_ICON"
                      eid={event.id}
                      onChangeImage={this.props.onChangeImage}
                      onDeleteImage={this.props.onDeleteImage}
                      onRequestLoading={this.props.onRequestLoading}
                      photoURL={`${IMAGE_PLAYER_ICON}?t=${this.props.timestamp}`}
                      onValidation={(file, _success) => {
                        const self = this;
                        var reader = new FileReader();

                        reader.onload = function (e) {
                          var img = new Image();
                          img.onload = function () {
                            if (this.width === 30 && this.height === 30) {
                              _success();
                            } else {
                              swal(
                                "",
                                "La imagen debe tener una dimensión de 30x30",
                                "error"
                              );
                              self.props.onRequestLoading(false);
                            }
                          };
                          img.src = e.target.result;
                        };

                        reader.readAsDataURL(file);
                      }}
                    />
                  </div>
                </div>

                <div className="row row-xs align-items-center mg-b-20">
                  <div className="col-md-4">
                    <label className="form-label mg-b-0">
                      Titulo del reproductor
                    </label>
                    <div className="alert alert-info" role="alert">
                      <strong>Aparecerá</strong> junto al ícono en tu
                      reproductor.
                    </div>
                  </div>
                  <div className="col-md-8 mg-t-5 mg-md-t-0">
                    <input
                      name="player_title"
                      type="text"
                      className="form-control"
                      defaultValue={_playerTitle}
                    />
                  </div>
                </div>

                <div className="row row-xs align-items-center mg-b-20 hide">
                  <div className="col-md-4">
                    <label className="form-label mg-b-0">Link</label>
                    <div className="alert alert-info" role="alert">
                      <strong>Al hacer clic </strong> sobre el icono el usuario
                      será enviado a este enlace..
                    </div>
                  </div>
                  <div className="col-md-8 mg-t-5 mg-md-t-0">
                    <input
                      name="player_destination"
                      type="text"
                      className="form-control"
                      defaultValue={_playerDestination}
                    />
                  </div>
                </div>

                <div className="row row-xs align-items-center mg-b-20">
                  <div className="col-md-4">
                    <label className="form-label mg-b-0">
                      Reproducir automáticamente al cargar{" "}
                    </label>
                  </div>
                  <div className="col-md-8 mg-t-5 mg-md-t-0">
                    <input
                      type="hidden"
                      name="player_autoplay"
                      value={playerAutoplay}
                      className="form-control"
                    />
                    <Switch
                      onChange={(newState, control) => {
                        this.setState({ playerAutoplay: newState });
                      }}
                      checked={playerAutoplay}
                    />
                  </div>
                </div>
                {this.state.hasYoutubeStreamTarget && (
                  <React.Fragment>
                    <div className="row row-xs align-items-center mg-b-20">
                      <div className="col-md-4">
                        <label className="form-label mg-b-0">
                          ¿Usar Reproductor de Youtube?{" "}
                          <small>
                            Esto te permitirá tener usuarios ilimitados
                          </small>
                        </label>
                      </div>
                      <div className="col-md-8 mg-t-5 mg-md-t-0">
                        <input
                          type="hidden"
                          name="player_useYoutube"
                          value={useYoutube}
                          className="form-control"
                        />
                        {isUpdatingYoutube && <h6>Actualizando...</h6>}
                        {!isUpdatingYoutube && (
                          <Switch
                            onChange={(newState, control) => {
                              this.setState({ isUpdatingYoutube: true }, () => {
                                this.props.firebase.db
                                  .collection("events")
                                  .doc(this.props.event.id)
                                  .update({
                                    "live_stream.isByYoutube": newState,
                                  })
                                  .then(() => {
                                    this.setState({
                                      isUpdatingYoutube: false,
                                      useYoutube: newState,
                                    });
                                  });
                              });
                            }}
                            checked={useYoutube}
                          />
                        )}
                      </div>
                    </div>
                    {useYoutube && (
                      <div className="row row-xs align-items-center mg-b-20">
                        <div className="col-md-4">
                          <label className="form-label mg-b-0">
                            URL del sitio en Youtube
                          </label>
                        </div>
                        <div className="col-md-8 mg-t-5 mg-md-t-0">
                          <input
                            name="youtube_url"
                            type="text"
                            className="form-control"
                            defaultValue={
                              this.props.event.live_stream.youtube_url || ""
                            }
                          />
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                )}
              </div>
              <div className="actions clearfix">
                <ul role="menu" aria-label="Pagination">
                  <li
                    className="disabled"
                    aria-hidden="false"
                    aria-disabled="false"
                  ></li>

                  <li aria-hidden="false" aria-disabled="false">
                    <button
                      disabled={isLoading}
                      type="submit"
                      className="btn btn-az-primary btn-block"
                      role="menuitem"
                    >
                      <i
                        className={
                          "fas fa-" + (isLoading ? "spinner fa-spin" : "save")
                        }
                      />{" "}
                      Guardar
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-4 row-eq-height mg-md-t-0 mg-xs-t-20 mg-sm-t-20">
          <div className="ht-100p">
            <div className="card card-body card-dashboard-twentyone mg-b-20 cnt0-preview-player">
              <h6>Tu reproductor se verá mas o menos asi:</h6>
              <div className="cnt-preview-player">
                <div className="custom_player_player">
                  <div className="video">
                    <i className="fas fa-play" />
                    <img src={`${IMAGE_PLAYER_BACKGROUND}?t=${this.props.timestamp}`} alt="background" />
                  </div>
                  <div className="player-bar">
                    <i className="fas fa-pause" />
                    <img src={IMAGE_PLAYER_ICON} alt="background" />
                  </div>
                </div>
              </div>
            </div>
            <div className="card card-body card-dashboard-twentyone cntO-embed-player">
              <div className="cnt-embed-player">
                <div className="cnt-embed-player-title">
                  <h6>El código para embeber el reproductor:</h6>

                  <button
                    className="btn btn-outline-primary"
                    onClick={() => {
                      sendToClipBoard(
                        _defaultCode,
                        "El código ha sido copiado"
                      );
                    }}
                  >
                    <i className="fas fa-copy" /> Copiar
                  </button>
                </div>

                <textarea
                  onFocus={(e) => {
                    e.target.focus();
                    e.target.select();
                  }}
                  readOnly={true}
                  value={_defaultCode}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomizePlayer;
